import { IconFlame } from "@tabler/icons-react";
import Calendar from "@/assets/icons/calendar.svg";
import Caterings from "@/assets/icons/caterings.svg";
import Meals from "@/assets/icons/meals.svg";
import { Badge } from "@/components/ui/badge";
import type { UITag } from "@/features/diets/types";
import { cn } from "@/lib/utils";

export const DietTags = ({
  tags,
  className,
}: {
  tags: UITag[];
  className?: string;
}) => {
  const innerTags = tags.map((tag) => {
    let icon: React.ReactNode = <></>;
    switch (tag.type) {
      case "days":
      case "calendar":
        icon = <Calendar className="h-4 w-4 [&>rect]:stroke-current" />;
        break;
      case "calories":
        icon = <IconFlame className="size-4" stroke={1.5} />;
        break;
      case "meals":
        icon = <Meals className="h-4 w-4" />;
        break;
      case "caterings":
        icon = <Caterings className="h-4 w-4" />;
        break;
      default:
        icon = <></>;
        break;
    }

    if (tag.icon) icon = tag.icon;

    return {
      name: tag.name,
      label: tag.label,
      icon: icon,
      className: tag.className,
    };
  });

  return innerTags.map((tag) => (
    <Badge
      variant="outline"
      className={cn("rounded-sm border-opacity-70 px-2 py-1.5", className)}
      key={`${tag.name}-${tag.label}`}
    >
      <span
        className={cn(
          "flex flex-nowrap items-center whitespace-nowrap font-medium text-xs opacity-70",
          tag.className,
        )}
      >
        {tag.icon}
        <span className="ml-2">{tag.label}</span>
      </span>
    </Badge>
  ));
};
